export default __webpack_public_path__ + "static/media/expl_013_DE.a3a5ffbd.png";